import { matchPath } from 'react-router';
import { createSelector } from 'reselect';
import {
  pathTypeOrder,
} from 'config/types/path';
import getPathMap from 'selectors/getPathMap';

/**
 * Find first path that matches pathname. A match is always expected to be
 * returned because of the open ended page path type will become the fallback.
 *
 * @param {Object} pathMap     Object with identifiers as keys and path regex as values.
 * @param {String} pathname    location pathname
 * @returns {Object}           react-router Match object
 */
const getFirstMatch = (pathMatchOrder, pathMap, pathname) => {
  const findFirst = (value) => !!value;
  return pathMatchOrder
    .map((pathType) => {
      const match = matchPath(pathname, {
        path: pathMap[pathType],
        exact: true,
      });

      if (!match) {
        return undefined;
      }

      match.pathType = pathType;

      return match;
    })
    .find(findFirst);
};

export default getFirstMatch;

const getRouter = (state) => state.router;

export const boundGetFirstMatch = createSelector(
  [getRouter, getPathMap],
  (router, pathMap) => getFirstMatch(pathTypeOrder, pathMap, router.location.pathname),
);
